module.exports = __webpack_public_path__ + "img/Facebook.5146a863.svg";